// =============================================================================================================
// SSO Hooks
// =============================================================================================================
import { useCallback } from 'react';
import { useStytchStartSSOFlow, useStytchGetSSOConnections, useStytchDiscoverSSOConnections, useStytchDeleteSSOConnection, useStytchAuthenticateSSO, } from '../../../../services/stytch/client';
/**
 * Hook to start SSO flow
 */
export function useStartSSOFlow() {
    const startSSOFlow = useStytchStartSSOFlow();
    return useCallback(async (data) => {
        const result = await startSSOFlow(data);
        if (result.success) {
            return {
                success: true,
                data: result.data,
            };
        }
        else {
            return {
                success: false,
                error: result.error,
                data: result.data,
            };
        }
    }, [startSSOFlow]);
}
export function useGetSSOConnections() {
    const getSSOConnections = useStytchGetSSOConnections();
    return useCallback(async () => {
        const result = await getSSOConnections();
        if (result.success) {
            const samlConnections = Array.isArray(result.samlConnections) ? result.samlConnections : [];
            const oidcConnections = Array.isArray(result.oidcConnections) ? result.oidcConnections : [];
            const externalConnections = Array.isArray(result.externalConnections) ? result.externalConnections : [];
            return {
                success: true,
                statusCode: result.statusCode,
                samlConnections,
                oidcConnections,
                externalConnections,
                data: result.data,
            };
        }
        else {
            return {
                success: false,
                error: result.error || 'Failed to fetch SSO connections',
                data: result.data,
            };
        }
    }, [getSSOConnections]);
}
export function useDiscoverSSOConnections() {
    const discoverSSOConnections = useStytchDiscoverSSOConnections();
    return useCallback(async (data) => {
        const result = await discoverSSOConnections(data);
        if (result.success) {
            const connections = Array.isArray(result.connections)
                ? result.connections
                : [];
            return {
                success: true,
                statusCode: result.statusCode,
                connections,
                data: result.data,
            };
        }
        else {
            return {
                success: false,
                error: result.error || 'Failed to discover SSO connections',
                data: result.data,
            };
        }
    }, [discoverSSOConnections]);
}
export function useDeleteSSOConnection() {
    const deleteSSOConnection = useStytchDeleteSSOConnection();
    return useCallback(async (data) => {
        const result = await deleteSSOConnection(data);
        if (result.success) {
            return {
                success: true,
                statusCode: result.statusCode,
                connectionId: result.connectionId,
                data: result.data,
            };
        }
        else {
            return {
                success: false,
                error: result.error,
                data: result.data,
            };
        }
    }, [deleteSSOConnection]);
}
/**
 * Hook to authenticate SSO token
 */
export function useAuthenticateSSO() {
    const authenticateSSO = useStytchAuthenticateSSO();
    return useCallback(async (data) => {
        const result = await authenticateSSO(data);
        if (result.success) {
            return {
                success: true,
                statusCode: result.statusCode,
                memberId: result.memberId,
                organizationId: result.organizationId,
                member: result.member,
                organization: result.organization,
                sessionToken: result.sessionToken,
                sessionJwt: result.sessionJwt,
                intermediateSessionToken: result.intermediateSessionToken,
                memberAuthenticated: result.memberAuthenticated,
                mfaRequired: result.mfaRequired,
                memberSession: result.memberSession,
                data: result.data,
            };
        }
        else {
            return {
                success: false,
                error: result.error,
                data: result.data,
            };
        }
    }, [authenticateSSO]);
}
